import { CardRec } from '@/components/common/Card'
import { type RecType } from '@/defs/rec'
import { cn } from '@/utils/commonUtil'

import { FeaturedRecOutboundBar } from '../FeaturedRecOutboundBar/FeaturedRecOutboundBar'

import styles from './FeaturedRecPartners.module.scss'
import { FeaturedRecPartnersChooser } from './FeaturedRecPartnersChooser/FeaturedRecPartnersChooser'

type Props = {
  rec: RecType
}

export const FeaturedRecPartners = ({ rec }: Props) => {
  const { partnerRef } = rec
  const isChooser = !partnerRef

  return (
    <div className={cn(styles.container, { isChooser, styles })}>
      <div className={styles.partner}>
        {isChooser ? (
          <FeaturedRecPartnersChooser />
        ) : (
          <>
            <CardRec disableLink extend rec={{ ...rec, onlyPartner: 'second' }} />
            <FeaturedRecOutboundBar rec={partnerRef} variant='partnerRight' />
          </>
        )}
      </div>
      <div className={styles.card}>
        <CardRec
          controls={isChooser ? 'left' : 'none'}
          disableLink
          extend={isChooser}
          rec={{ ...rec, onlyPartner: 'first' }}
        />
        <FeaturedRecOutboundBar rec={rec} variant='partnerLeft' />
      </div>
    </div>
  )
}
